export default __webpack_public_path__ + "static/media/instagram-icon.dc4bdbb9.svg";